/* eslint-disable */
/* eslint-disable no-confusing-arrow */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { IAccrualPlanColumns, ISettings, IUser } from 'src/interfaces';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import {
  AlertAdapter,
  DataTableCellDeleteButton,
  DataTableCellEditButton,
  Loader,
  RegularButton,
  CommonInput,
} from 'pg-ui-library';
import './index.css';
import { DefaultTable } from 'src/components';
import { TableColumn } from 'react-data-table-component';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import PaymentsService from 'src/services/payments.service';
import CompanyService from 'src/services/company.services';
import UserService from 'src/services/user.service';
import { usePatchSettings } from './mutations/patch-settings.mutation';
import { useSettings } from './queries/settings.query';
import {
  DataGrid,
  GridColDef,
  GridRenderCellParams,
  GridValueFormatter,
  GridValueGetter,
  GridPaginationModel,
  GridSortModel,
  GridRowClassNameParams,
} from '@mui/x-data-grid';

import {
  CompanyContainer,
  CompanyHeader,
  Container,
  Content,
  EmptyContainer,
  FeatureToggleLine,
  Header,
  LeaveContainer,
  LeaveHeader,
  Tab,
  TabContainer,
  TabTitle,
  Title,
} from './styles';
import { AccrualPlanModal } from './components/accrual-plan-modal';
import AddCompanies from './components/add-company-modal';
import { PayrollSummariesConfigTable } from './components/payroll-setings';

import { SupportEditModal } from './components/edit-support-modal';
import { UserEditModal } from './components/edit-user-modal';
import { UserEditAdminModal } from './components/edit-admin-user-modal';
import AddUsers from './components/add-adminusers-modal';
import AddSupportAdminUsers from './components/add-supportadminusers-modal';
import UpdateSubModuleEmail from './components/update-email-module';
import AddExternalUserModal from './components/add-external-user-modal';
import { t } from 'i18next';
import { userDeleteExternalUser } from './mutations/external-user.mutation';
import YearEndFormsService from 'src/services/year-end-forms.service';

import ExternalClientUsersTab from './components/external-client-users-tab';
import { ExternalModal } from './components/external-edit-modal';
import { AddExternalClientUserModal } from './components/external-client-modal';

interface SetDataAction {
  type: 'SET_DATA';
  payload: ISettings;
}

interface ToggleFeatureAction {
  type: 'TOGGLE_FEATURE';
  tab: string;
  id: string;
  value: boolean;
}

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 15px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
      '&:last-of-type': {
        marginRight: '50px',
        justifyContent: 'end',
      },
    },
  },
  pagination: {
    style: {
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

type SettingsAction = SetDataAction | ToggleFeatureAction;

const settingsReducer = (state: ISettings, action: SettingsAction) => {
  switch (action.type) {
    case 'SET_DATA':
      return action.payload;
    case 'TOGGLE_FEATURE':
      return {
        ...state,
        [action.tab]: state[action.tab].map(item =>
          item.id === action.id ? { ...item, enabled: action.value } : item
        ),
      };
    default:
      return state;
  }
};

const W2FormSettings = () => {
  const { isFetching, data, refetch } = useQuery(['w2-form/config'], async () => {
    const result = await YearEndFormsService.w2FormConfig();
    return result;
  });

  const mutation = useMutation((enable: boolean) => YearEndFormsService.w2FormConfigPost(enable), {
    onSuccess: () => {
      AlertAdapter('W2 form settings updated', 'success');
      refetch();
    },
    onError: () => {
      AlertAdapter('Failed to delete', 'error');
    },
  });

  return (
    <>
      <div>
        <FeatureToggleLine>
          <div style={{ width: '30%' }}>
            <span>Enable Address sync</span>
          </div>
          <div style={{ width: '50vw' }}>
            <label className="switch">
              <input
                type="checkbox"
                checked={data?.data[0].enabled || isFetching}
                onChange={e => {
                  mutation.mutate(!data?.data[0].enabled);
                }}
              />
              <span className="slider round" />
            </label>
          </div>
          <div>
            <span style={{ color: 'red', fontSize: '13pt', width: '100%', marginLeft: '-100%' }}>
              Note: This setting will enable to use employee primary address from profile to print in W2.
            </span>
          </div>
        </FeatureToggleLine>
      </div>
    </>
  );
};

const ExternalAdminUsersTab = () => {
  const queryClient = useQueryClient();
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pageUser, setPageUser] = useState(1);
  const [limitUser, setLimitUser] = useState(10);
  const [sortByUser, setSortByUser] = useState('');
  const [sortDirectionUser, setSortDirectionUser] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [isOpenEditUser, setIsOpenEditUser] = useState(false);
  const [updateUser, setUpdateUser] = useState<IUser | undefined>(undefined);

  const handlePageChange = (nPage: number) => {
    setPageUser(nPage);
  };

  const editButtonUserWrapper = (onClick: Function) => <DataTableCellEditButton onClick={() => onClick()} />;

  const handlePerRowsChange = async (newLimit: number, nPage: number) => {
    setPageUser(nPage);
    setLimitUser(newLimit);
  };

  const handleSortExternalUser = async (field: string, newSortDirection: 'asc' | 'desc') => {
    setSortByUser(field);
    setSortDirectionUser(newSortDirection);
  };

  const onEdit = (user: IUser) => {
    setUpdateUser(user);
    setIsOpenEditUser(true);
  };

  const {
    data: users,
    refetch: refetchUsers,
    isFetching: isFetchingUsers,
  } = useQuery(
    ['external-users'],
    () =>
      UserService.getExternalUsers({
        page: pageUser,
        limit: limitUser,
        sortBy: sortByUser,
        sortDirection: sortDirectionUser,
      }),
    {
      enabled: true,
    }
  );

  const externalAdminUsersColumns: GridColDef[] = [
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 300,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => onEdit(row)}>
              {editButtonUserWrapper(() => onEdit(row))}
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <CompanyContainer>
        {updateUser && (
          <ExternalModal
            isOpen={isOpenEditUser}
            setIsOpen={setIsOpenEditUser}
            user={updateUser}
            onSuccess={() => {
              setIsOpenEditUser(false);
              refetchUsers();
            }}
          />
        )}

        <AddExternalUserModal isOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} />
        <CompanyHeader>
          <h4>{t('settings.externalUsers.text3')}</h4>
          <RegularButton style={{ marginTop: '25px' }} onClick={() => setIsModalOpen(true)}>
            {t('global.form.add')}
          </RegularButton>
        </CompanyHeader>
      </CompanyContainer>
      <div style={{ alignSelf: 'right', minWidth: '100%' }}>
        <DataGrid
          rows={users?.data?.items || []}
          columns={externalAdminUsersColumns}
          pagination
          paginationMode="server"
          onPaginationModelChange={state => {
            handlePageChange(state.page + 1);
            handlePerRowsChange(state.pageSize, state.page + 1);
          }}
          onSortModelChange={sortModel => {
            if (sortModel.length > 0) {
              const { field, sort } = sortModel[0];
              handleSortExternalUser(field, sort as 'asc' | 'desc');
            }
          }}
          getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 20, 50]}
          rowHeight={42}
          rowCount={totalRows}
          loading={isFetchingUsers}
          disableColumnFilter
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            '& .first-column-cell': {
              paddingLeft: '200px',
            },
            '& .striped-row': {
              backgroundColor: '#F3F4F8',
              color: '#1B1D35',
            },
            minHeight: '150px',
            background: '#fff',
          }}
        />
      </div>
    </>
  );
};

// const ExternalClientUsersTab = () => {
//   const queryClient = useQueryClient();
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [pageUser, setPageUser] = useState(1);
//   const [limitUser, setLimitUser] = useState(10);
//   const [sortByUser, setSortByUser] = useState('');
//   const [sortDirectionUser, setSortDirectionUser] = useState('');
//   const [totalRows, setTotalRows] = useState(0);
//   const [isOpenEditUser, setIsOpenEditUser] = useState(false);
//   const [updateUser, setUpdateUser] = useState<IUser | undefined>(undefined);

//   const handlePageChange = (nPage: number) => {
//     setPageUser(nPage);
//   };

//   const editButtonUserWrapper = (onClick: Function) => <DataTableCellEditButton onClick={() => onClick()} />;

//   const handlePerRowsChange = async (newLimit: number, nPage: number) => {
//     setPageUser(nPage);
//     setLimitUser(newLimit);
//   };

//   const handleSortExternalUser = async (field: string, newSortDirection: 'asc' | 'desc') => {
//     setSortByUser(field);
//     setSortDirectionUser(newSortDirection);
//   };

//   const onEdit = (user: IUser) => {
//     setUpdateUser(user);
//     setIsOpenEditUser(true);
//   };

//   const {
//     data: users,
//     refetch: refetchUsers,
//     isFetching: isFetchingUsers,
//   } = useQuery(
//     ['external-client-users'],
//     () =>
//       UserService.getExternalClientUsers({
//         page: pageUser,
//         limit: limitUser,
//         sortBy: sortByUser,
//         sortDirection: sortDirectionUser,
//       }),
//     {
//       enabled: true,
//     }
//   );

//   const externalAdminUsersColumns: GridColDef[] = [
//     {
//       headerName: 'Email',
//       field: 'email',
//       minWidth: 300,
//       sortable: true,
//       filterable: true,
//     },
//     {
//       headerName: 'Actions',
//       field: 'actions',
//       minWidth: 150,
//       sortable: false,
//       filterable: false,
//       renderCell: params => {
//         const row = params.row as IUser;
//         return (
//           <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//             <div style={{ cursor: 'pointer' }} onClick={() => onEdit(row)}>
//               {editButtonUserWrapper(() => onEdit(row))}
//             </div>
//           </div>
//         );
//       },
//     },
//   ];

//   return (
//     <>
//       <CompanyContainer>
//         {updateUser && (
//           <ExternalModal
//             isOpen={isOpenEditUser}
//             setIsOpen={setIsOpenEditUser}
//             user={updateUser}
//             onSuccess={() => {
//               setIsOpenEditUser(false);
//               refetchUsers();
//             }}
//           />
//         )}

//         {/* <AddExternalUserModal isOpen={isModalOpen} onRequestClose={() => setIsModalOpen(false)} /> */}
//         <AddExternalClientUserModal
//           isOpen={isModalOpen}
//           onRequestClose={() => setIsModalOpen(false)}
//           onSuccess={refetchUsers}
//         />

//         <CompanyHeader>
//           <h4>{t('settings.externalClientUsers')}</h4>
//           <RegularButton style={{ marginTop: '25px' }} onClick={() => setIsModalOpen(true)}>
//             {t('global.form.add')}
//           </RegularButton>
//         </CompanyHeader>
//       </CompanyContainer>
//       <div style={{ alignSelf: 'right', minWidth: '100%' }}>
//         <DataGrid
//           rows={users?.data?.items || []}
//           columns={externalAdminUsersColumns}
//           pagination
//           paginationMode="server"
//           onPaginationModelChange={state => {
//             handlePageChange(state.page + 1);
//             handlePerRowsChange(state.pageSize, state.page + 1);
//           }}
//           onSortModelChange={sortModel => {
//             if (sortModel.length > 0) {
//               const { field, sort } = sortModel[0];
//               handleSortExternalUser(field, sort as 'asc' | 'desc');
//             }
//           }}
//           getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
//           initialState={{
//             pagination: {
//               paginationModel: { page: 0, pageSize: 10 },
//             },
//           }}
//           pageSizeOptions={[10, 20, 50]}
//           rowHeight={42}
//           rowCount={totalRows}
//           loading={isFetchingUsers}
//           disableColumnFilter
//           sx={{
//             font: '14px Biotif',
//             fontWeight: 'bold',
//             '& .CommonHeaderClass': {
//               color: '#9399B2',
//               font: '16px Biotif',
//               fontWeight: 'bold',
//             },
//             '& .first-column-cell': {
//               paddingLeft: '200px',
//             },
//             '& .striped-row': {
//               backgroundColor: '#F3F4F8',
//               color: '#1B1D35',
//             },
//             minHeight: '150px',
//             background: '#fff',
//           }}
//         />
//       </div>
//     </>
//   );
// };

export const Settings: React.FC = () => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<string>();
  const companyId = useTypedSelector(state => state.config.data?.config?.selectedCompanyId) || '';
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isUserModalOpen, setIsUserModalOpen] = useState<boolean>(false);
  const [isOpenEditUser, setIsOpenEditUser] = useState<boolean>(false);
  const [isOpenEditAdminUser, setIsOpenEditAdminUser] = useState<boolean>(false);
  const [isOpenEditUserSupport, setIsOpenEditUserSupport] = useState<boolean>(false);
  const [isOpenEditAdminUserAdd, setIsOpenEditAdminUserAdd] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [pageUser, setPageUser] = useState(1);
  const [limitUser, setLimitUser] = useState(10);
  const [sortByUser, setSortByUser] = useState('');
  const [sortDirectionUser, setSortDirectionUser] = useState('');
  const [pageAdminUser, setPageAdminUser] = useState(1);
  const [pageSupportAdminUser, setPageSupportAdminUser] = useState(1);
  const [limitAdminUser, setLimitAdminUser] = useState(10);
  const [limitSupportAdminUser, setLimitSupportAdminUser] = useState(10);
  const [sortByAdminUser, setSortByAdminUser] = useState('');
  const [sortBySupportAdminUser, setSortBySupportAdminUser] = useState('');
  const [sortDirectionAdminUser, setSortDirectionAdminUser] = useState('');
  const [sortDirectionSupportAdminUser, setSortDirectionSupportAdminUser] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [totalRowsCompany, setTotalRowsCompany] = useState(0);
  const [totalRowsUser, setTotalRowsUser] = useState(0);
  const [totalRowsAdminUser, setTotalRowsAdminUser] = useState(0);
  const [totalRowsAdminUserSupport, setTotalRowsAdminUserSupport] = useState(0);
  const { data, isFetching, isLoading } = useSettings({ companyId });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEmail, setIsModalOpenEmail] = useState(false);
  const [updateUser, setUpdateUser] = useState<IUser>();
  const [isModalOpenAdmin, setIsModalOpenAdmin] = useState(false);

  const [searchTermUsers, setsearchTermUsers] = useState('');
  const [searchTermAdminUsers, setsearchTermAdminUsers] = useState('');
  const [searchTermSupportAdminUsers, setsearchTermSupportAdminUsers] = useState('');
  const { data: companies, refetch: fetchingCompanies } = useQuery({
    queryKey: ['users/companies'],
    queryFn: () => CompanyService.getCompanies(),
    enabled: true,
  });

  const {
    data: users,
    refetch: refetchUsers,
    isFetching: isFetchingUsers,
  } = useQuery(
    ['users'],
    () =>
      UserService.getUsers({
        page: pageUser,
        limit: limitUser,
        sortBy: sortByUser,
        sortDirection: sortDirectionUser,
        search: searchTermUsers,
      }),
    {
      enabled: true,
    }
  );
  const {
    data: adminUsers,
    refetch: refetchAdminUsers,
    isFetching: isFetchingAdminUsers,
  } = useQuery(
    ['usersAdmin'],
    () =>
      UserService.getAdminUsers({
        page: pageAdminUser,
        limit: limitAdminUser,
        sortBy: sortByAdminUser,
        sortDirection: sortDirectionAdminUser,
        search: searchTermAdminUsers,
      }),
    {
      enabled: true,
    }
  );

  const {
    data: adminUsersSupport,
    refetch: refetchAdminUsersSupport,
    isFetching: isFetchingAdminUsersSupport,
  } = useQuery(
    ['usersAdminSupport'],
    () =>
      UserService.getAdminUsersSupport({
        page: pageSupportAdminUser,
        limit: limitSupportAdminUser,
        sortBy: sortBySupportAdminUser,
        sortDirection: sortDirectionSupportAdminUser,
        search: searchTermSupportAdminUsers,
      }),
    {
      enabled: true,
    }
  );

  const {
    data: accrualPlans,
    refetch: refetchAccrualPlans,
    isFetching: isFetchingPlans,
  } = useQuery(['accrual-id-config'], () => PaymentsService.getAccrualPlans({ page, limit, sortBy, sortDirection }), {
    enabled: true,
  });
  const mutation = useMutation((id: string) => PaymentsService.deleteAccrualIdConfig(id), {
    onSuccess: () => {
      AlertAdapter('Accrual plan config deleted', 'success');
      refetchAccrualPlans();
    },
    onError: () => {
      AlertAdapter('Failed to delete', 'error');
    },
  });

  const mutationComapny = useMutation((id: string) => CompanyService.deleteCompanyIdConfig(id), {
    onSuccess: () => {
      AlertAdapter('Comapny is deleted', 'success');
      fetchingCompanies();
    },
    onError: () => {
      AlertAdapter('Failed to delete', 'error');
    },
  });

  const deleteButtonWrapper = (onClick: Function) => (
    <DataTableCellDeleteButton style={{ width: '50px' }} onClick={() => (!mutation.isLoading ? onClick() : '')} />
  );
  const deleteButtonWrapperCompany = (onClick: Function) => (
    <DataTableCellDeleteButton
      style={{ width: '50px' }}
      onClick={() => (!mutationComapny.isLoading ? onClick() : '')}
    />
  );

  const editButtonUserWrapper = (onClick: Function) => <DataTableCellEditButton onClick={() => onClick()} />;
  const deleteButtonUserWrapper = (onClick: Function) => <DataTableCellDeleteButton onClick={() => onClick()} />;

  const deleteConfig = (id: any) => {
    mutation.mutate(id);
  };
  const deleteConfigCompany = (id: any) => {
    mutationComapny.mutate(id);
  };

  const [state, dispatch] = useReducer(settingsReducer, data || {});

  const patchMutation = usePatchSettings();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const openModalAdmin = () => setIsModalOpenAdmin(true);
  const closeModalAdmin = () => setIsModalOpenAdmin(false);

  const tabs = [
    {
      key: 0,
      selectedTab: 'notifications',
      lable: 'Notifications',
    },
    {
      key: 1,
      selectedTab: 'accrualPlan',
      lable: 'Leave',
    },
    {
      key: 2,
      selectedTab: 'company',
      lable: 'Company',
    },
    {
      key: 3,
      selectedTab: 'users',
      lable: 'Users',
    },
    {
      key: 4,
      selectedTab: 'adminUser',
      lable: 'Admin User',
    },
    {
      key: 5,
      selectedTab: 'supportAdminUser',
      lable: 'Support Admin User',
    },
    {
      key: 6,
      selectedTab: 'externalAdminUsers',
      lable: 'External Admin User',
    },
    {
      key: 7,
      selectedTab: 'ExternalClientUsers',
      lable: 'External Client User',
    },
    {
      key: 8,
      selectedTab: 'w2FormSettings',
      lable: 'W2 Forms',
    },
  ];

  const columns: GridColDef[] = [
    {
      headerName: 'Accrual Id',
      field: 'accrualId',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Accrual Id',
      field: 'accrualId',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Company',
      field: 'company',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Description',
      field: 'description',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => deleteConfig(row)}>
              {deleteButtonWrapper(() => deleteConfig(row))}
            </div>
          </div>
        );
      },
    },
  ];

  const companyColumns: GridColDef[] = [
    {
      headerName: 'Company Id',
      field: 'legalEntityId',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Company Name',
      field: 'name',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Phone',
      field: 'phone',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Identification number',
      field: 'identificationNumber',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => deleteConfigCompany(row)}>
              {deleteButtonWrapperCompany(() => deleteConfigCompany(row))}
            </div>
          </div>
        );
      },
    },
  ];

  const userDetail = users?.data as IUser | undefined;

  const formatDate = (date: Date | string | undefined): string => {
    if (date instanceof Date) {
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    }
    if (typeof date === 'string') {
      const parsedDate = new Date(date);
      return isNaN(parsedDate.getTime())
        ? ''
        : parsedDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          });
    }
    return '';
  };

  const permissionLabels: { [key: string]: string } = {
    benefits: 'Benefits',
    pay_history: 'Pay History',
    documents: 'Documents',
    hr_profile: 'HR Profile',
    admin: 'Admin',
    tax_forms: 'Tax Forms',
  };

  const usersColumns: GridColDef[] = [
    {
      headerName: 'Name',
      field: 'name',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Employee ID',
      field: 'employeeNickId',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 250,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Hire Date',
      headerClassName: 'CommonHeaderClass',
      field: 'hireDate',
      minWidth: 150,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Termination Date',
      headerClassName: 'CommonHeaderClass',
      field: 'terminationDate',
      minWidth: 150,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Permissions',
      field: 'permissionsUser',
      minWidth: 200,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        if (row && row.permissionsUser) {
          const permissions = Object.entries(row.permissionsUser)
            .filter(([_, hasPermission]) => hasPermission)
            .map(([permission]) => permission);
          return <span>{permissions.join(', ')}</span>;
        }
        return <span>No Permissions</span>;
      },
    },
    {
      headerName: 'Status',
      field: 'isActive',
      minWidth: 130,
      sortable: true,
      filterable: true,
      renderCell: params => {
        return <span>{params.row.isActive ? 'Active' : 'Inactive'}</span>;
      },
    },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => onEdit(row)}>
              {editButtonUserWrapper(() => onEdit(row))}
            </div>
          </div>
        );
      },
    },
  ];

  const AdminusersColumns: GridColDef[] = [
    {
      headerName: 'Name',
      field: 'name',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      field: 'permissions',
      headerName: 'Permissions',
      minWidth: 200,
      sortable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return Object.entries(row.permissionsUser)
          .filter(([_, hasPermission]) => hasPermission)
          .map(([permission]) => permission)
          .join(', ');
      },
    },
    {
      headerName: 'Status',
      field: 'isActive',
      minWidth: 130,
      sortable: true,
      filterable: true,
      renderCell: params => {
        return <span>{params.row.isActive ? 'Active' : 'Inactive'}</span>;
      },
    },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => onEditAdmin(row)}>
              {editButtonUserWrapper(() => onEditAdmin(row))}
            </div>
          </div>
        );
      },
    },
  ];

  const SupportadminusersColumns: GridColDef[] = [
    {
      headerName: 'Name',
      field: 'name',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      field: 'permissions',
      headerName: 'Module',
      minWidth: 200,
      sortable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return Object.entries(row.permissionsUser)
          .filter(([_, hasPermission]) => hasPermission)
          .map(([permission]) => permission)
          .join(', ');
      },
    },
    {
      headerName: 'Application',
      field: 'applications',
      minWidth: 180,
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Status',
      field: 'isActive',
      minWidth: 130,
      sortable: true,
      filterable: true,
      renderCell: params => {
        return <span>{params.row.isActive ? 'Active' : 'Inactive'}</span>;
      },
    },
    {
      headerName: 'Actions',
      field: 'actions',
      minWidth: 150,
      sortable: false,
      filterable: false,
      renderCell: params => {
        const row = params.row as IUser;
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ cursor: 'pointer' }} onClick={() => onuserEdit(row)}>
              {editButtonUserWrapper(() => onuserEdit(row))}
            </div>
          </div>
        );
      },
    },
  ];

  const onEdit = (user: IUser) => {
    setUpdateUser(user);
    setIsOpenEditUser(true);
  };
  const onEditAdmin = (user: IUser) => {
    setUpdateUser(user);
    setIsOpenEditAdminUser(true);
  };

  const onuserEdit = (user: IUser) => {
    setUpdateUser(user);
    setIsOpenEditUserSupport(true);
    setIsUserModalOpen(true);
  };

  const handlePageChange = (nPage: number) => {
    setPage(nPage);
  };

  const handlePageChangeUser = (nPage: number) => {
    setPageUser(nPage);
  };
  const handlePageChangeAdminUser = (nPage: number) => {
    setPageAdminUser(nPage);
  };
  const handlePageChangeSupportAdminUser = (nPage: number) => {
    setPageSupportAdminUser(nPage);
  };

  const handlePerRowsChange = async (newLimit: number, nPage: number) => {
    setPage(nPage);
    setLimit(newLimit);
  };

  const handleSortUser = async (field: string, newSortDirection: 'asc' | 'desc') => {
    setSortByUser(field);
    setSortDirectionUser(newSortDirection);
  };

  const handlePerRowsChangeUser = async (newLimit: number, nPage: number) => {
    setPageUser(nPage);
    setLimitUser(newLimit);
  };

  const handleSortAdminUser = async (field: string, newSortDirection: 'asc' | 'desc') => {
    setSortByAdminUser(field);
    setSortDirectionAdminUser(newSortDirection);
  };

  const handleSortSupportAdmin = async (field: string, newSortDirection: 'asc' | 'desc') => {
    setSortBySupportAdminUser(field);
    setSortDirectionSupportAdminUser(newSortDirection);
  };

  const handlePerRowsChangeAdminUser = async (newLimit: number, nPage: number) => {
    setPageAdminUser(nPage);
    setLimitAdminUser(newLimit);
  };
  const handlePerRowsChangeSupportAdminUser = async (newLimit: number, nPage: number) => {
    setPageSupportAdminUser(nPage);
    setLimitSupportAdminUser(newLimit);
  };

  const handleSort = async (field: string, newSortDirection: 'asc' | 'desc') => {
    setSortBy(field);
    setSortDirection(newSortDirection);
  };
  const handleSortCompany = async (field: string, newSortDirection: 'asc' | 'desc') => {
    setSortBy(field);
    setSortDirection(newSortDirection);
  };

  useEffect(() => {
    refetchUsers();
  }, [pageUser, limitUser, sortByUser, searchTermUsers, sortDirectionUser, isOpenEditAdminUser]);

  useEffect(() => {
    refetchAdminUsers();
  }, [
    pageAdminUser,
    limitAdminUser,
    sortByAdminUser,
    searchTermAdminUsers,
    sortDirectionAdminUser,
    isOpenEditAdminUser,
  ]);

  useEffect(() => {
    refetchAdminUsersSupport();
  }, [
    pageSupportAdminUser,
    limitSupportAdminUser,
    sortBySupportAdminUser,
    searchTermSupportAdminUsers,
    sortDirectionSupportAdminUser,
    isOpenEditAdminUser,
  ]);

  useEffect(() => {
    setTotalRowsUser(users?.data?.meta?.totalItems || 0);
    setTotalRowsAdminUser(adminUsers?.data?.meta?.totalItems || 0);
    setTotalRowsAdminUserSupport(adminUsersSupport?.data?.meta?.totalItems || 0);
  }, [users, adminUsers, adminUsersSupport]);

  useEffect(() => {
    refetchAccrualPlans();
  }, [isOpen]);

  useEffect(() => {
    refetchAccrualPlans();
  }, [page, limit, sortBy, sortDirection, isOpen]);

  useEffect(() => {
    setTotalRows(accrualPlans?.data?.meta?.totalItems?.totalItems || 0);
  }, [accrualPlans]);

  const getNotificationsTabContent = () => {
    if (data && selectedTab) {
      return state[selectedTab].map((item: { id: string; enabled: boolean; description: string }) => (
        <FeatureToggleLine key={item.id}>
          <div style={{ width: '50vw' }}>
            <span>{item.description}</span>
          </div>
          <div style={{ width: '50vw' }}>
            <label className="switch">
              <input
                disabled={patchMutation.isLoading}
                type="checkbox"
                checked={item.enabled}
                onChange={e => {
                  dispatch({
                    type: 'TOGGLE_FEATURE',
                    tab: selectedTab,
                    id: item.id,
                    value: e.target.checked,
                  });
                  patchMutation.mutateAsync({ id: item.id, value: e.target.checked }).catch(() => {
                    dispatch({
                      type: 'TOGGLE_FEATURE',
                      tab: selectedTab,
                      id: item.id,
                      value: !e.target.checked,
                    });
                  });
                }}
              />
              <span className="slider round" />
            </label>
          </div>
        </FeatureToggleLine>
      ));
    }
    return <EmptyContainer>{t('global.form.empty')}</EmptyContainer>;
  };

  const getAccrualPlanTabContent = () => (
    <>
      <LeaveContainer>
        <AccrualPlanModal isOpen={isOpen} setIsOpen={setIsOpen} refetchAccrualPlans={refetchAccrualPlans} />
        <LeaveHeader>
          <h4>{t('settings.title.leave')}</h4>
          <RegularButton
            style={{ marginTop: '25px' }}
            onClick={() => {
              setIsOpen(true);
            }}
          >
            {t('settings.title.button')}
          </RegularButton>
        </LeaveHeader>
      </LeaveContainer>
      <div style={{ alignSelf: 'right', minWidth: '100%' }}>
        <DataGrid
          rows={accrualPlans?.data?.items || []}
          columns={columns}
          pagination
          paginationMode="server"
          onPaginationModelChange={state => {
            handlePageChange(state.page + 1);
            handlePerRowsChange(state.pageSize, state.page + 1);
          }}
          onSortModelChange={sortModel => {
            if (sortModel.length > 0) {
              const { field, sort } = sortModel[0];
              handleSort(field, sort as 'asc' | 'desc');
            }
          }}
          getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 20, 50]}
          rowHeight={42}
          rowCount={totalRows}
          loading={mutation.isLoading || isFetchingPlans}
          disableColumnFilter
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            '& .first-column-cell': {
              paddingLeft: '200px',
            },
            '& .striped-row': {
              backgroundColor: '#F3F4F8',
              color: '#1B1D35',
            },
            minHeight: '150px',
            background: '#fff',
          }}
        />
      </div>
    </>
  );

  const getCompanydata = () => (
    <>
      <CompanyContainer>
        <AddCompanies isOpen={isModalOpen} onRequestClose={closeModal} />
        <CompanyHeader>
          <h4>{t('settings.title.Company')}</h4>
          <RegularButton style={{ marginTop: '25px' }} onClick={openModal}>
            {t('settings.title.companybutton')}
          </RegularButton>
        </CompanyHeader>
      </CompanyContainer>
      {/* <div style={{ alignSelf: 'right', minWidth: '100%' }}>
        <DataGrid
          rows={companies?.data?.items || []}
          columns={companyColumns}
          pagination
          paginationMode="server"
          onPaginationModelChange={state => {
            handlePageChange(state.page + 1);
            handlePerRowsChange(state.pageSize, state.page + 1);
          }}
          onSortModelChange={sortModel => {
            if (sortModel.length > 0) {
              const { field, sort } = sortModel[0];
              handleSortCompany(field, sort as 'asc' | 'desc');
            }
          }}
          getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          // pageSizeOptions={[10, 20, 50]}
          rowHeight={42}
          rowCount={totalRowsCompany}
          loading={mutation.isLoading || isFetchingPlans}
          disableColumnFilter
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            '& .first-column-cell': {
              paddingLeft: '200px',
            },
            '& .striped-row': {
              backgroundColor: '#F3F4F8',
              color: '#1B1D35',
            },
            minHeight: '150px',
            background: '#fff',
          }}
        />
      </div> */}

      <div style={{ alignSelf: 'right', minWidth: '100%' }}>
        <DataGrid
          rows={companies?.data?.items || []}
          columns={companyColumns}
          getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
          rowHeight={42}
          loading={mutation.isLoading || isFetchingPlans}
          disableColumnFilter
          hideFooterPagination
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            '& .first-column-cell': {
              paddingLeft: '200px',
            },
            '& .striped-row': {
              backgroundColor: '#F3F4F8',
              color: '#1B1D35',
            },
            minHeight: '150px',
            background: '#fff',
          }}
        />
      </div>
    </>
  );

  const handleModalClose = async () => {
    setIsOpenEditUser(false);
    setIsUserModalOpen;
    refetchUsers();
  };

  const handleModalCloseAdmin = async () => {
    setIsOpenEditAdminUser(false);
    setIsUserModalOpen;
    refetchAdminUsers();
  };

  const handlesupportModalClose = async () => {
    setIsOpenEditUserSupport(false);
    refetchAdminUsersSupport();
  };

  const closeModalSupport = async () => {
    setIsModalOpen(false);
    refetchAdminUsersSupport();
  };

  const closeModalSupportEmail = async () => {
    setIsModalOpenEmail(false);
  };

  const handleUserModalClose = async () => {
    setIsOpenEditUser(false);
    setIsUserModalOpen;
    refetchUsers();
  };
  const handleModalAdminClose = async () => {
    setIsOpenEditUser(false);
    refetchAdminUsers();
  };

  const handleModalAdminCloseAdd = async () => {
    setIsOpenEditAdminUserAdd(false);
    refetchAdminUsers();
  };

  const getUsersdata = () => (
    <>
      <CompanyContainer>
        {updateUser && (
          <UserEditModal
            isOpen={isOpenEditUser}
            setIsOpen={setIsOpenEditUser}
            user={updateUser}
            onSuccess={handleModalClose}
          />
        )}
        <CompanyHeader>
          <h4> User List</h4>
          <div style={{ marginTop: '10px' }}>
            <CommonInput
              id="searchQuery"
              name="searchQuery"
              placeholder="Search..."
              value={searchTermUsers}
              onChange={event => {
                let newValue = event.target.value;
                newValue = newValue.replace(/[',.]/g, '');
                setsearchTermUsers(newValue);
              }}
              style={{
                width: '300px',
                marginRight: '10px',
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '4px',
                minHeight: '25px',
              }}
              label=""
            />
          </div>
        </CompanyHeader>
      </CompanyContainer>
      <div style={{ alignSelf: 'right', minWidth: '100%' }}>
        <DataGrid
          rows={users?.data?.items || []}
          columns={usersColumns}
          pagination
          paginationMode="server"
          onPaginationModelChange={state => {
            handlePageChangeUser(state.page + 1);
            handlePerRowsChangeUser(state.pageSize, state.page + 1);
          }}
          onSortModelChange={sortModel => {
            if (sortModel.length > 0) {
              const { field, sort } = sortModel[0];
              handleSortUser(field, sort as 'asc' | 'desc');
            }
          }}
          getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: limitUser },
            },
          }}
          pageSizeOptions={[10, 20, 50]}
          rowCount={totalRowsUser}
          rowHeight={42}
          loading={mutation.isLoading || isFetchingPlans}
          disableColumnFilter
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            '& .striped-row': {
              backgroundColor: '#F3F4F8',
              color: '#1B1D35',
            },
            minHeight: '150px',
            background: '#fff',
          }}
        />
      </div>
    </>
  );

  const getSupportadminusersdata = () => (
    <>
      <CompanyContainer>
        {updateUser && (
          <SupportEditModal
            isOpen={isOpenEditUserSupport}
            setIsOpen={setIsUserModalOpen}
            user={updateUser}
            onSuccess={handlesupportModalClose}
          />
        )}
        <AddSupportAdminUsers isOpen={isModalOpen} onRequestClose={closeModalSupport} />
        <UpdateSubModuleEmail isOpen={isModalOpenEmail} onRequestClose={closeModalSupportEmail} />
        <CompanyHeader>
          <h4>Support Admin User</h4>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginTop: '10px' }}>
              <CommonInput
                id="searchQuery"
                name="searchQuery"
                placeholder="Search..."
                value={searchTermSupportAdminUsers}
                onChange={event => {
                  let newValue = event.target.value;
                  newValue = newValue.replace(/[',.]/g, '');
                  setsearchTermSupportAdminUsers(newValue);
                }}
                style={{
                  width: '300px',
                  marginRight: '10px',
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  padding: '4px',
                  minHeight: '30px',
                }}
                label=""
              />
            </div>
            <div>
              <RegularButton style={{ marginTop: '25px' }} onClick={openModal}>
                Add Support Admin User
              </RegularButton>
              <RegularButton
                style={{ marginTop: '25px' }}
                onClick={() => {
                  setIsModalOpenEmail(true);
                }}
              >
                Update Email
              </RegularButton>
            </div>
          </div>
        </CompanyHeader>
      </CompanyContainer>
      <div style={{ alignSelf: 'right', minWidth: '100%' }}>
        <DataGrid
          rows={adminUsersSupport?.data?.items || []}
          columns={SupportadminusersColumns}
          pagination
          paginationMode="server"
          onPaginationModelChange={state => {
            handlePageChangeSupportAdminUser(state.page + 1);
            handlePerRowsChangeSupportAdminUser(state.pageSize, state.page + 1);
          }}
          onSortModelChange={sortModel => {
            if (sortModel.length > 0) {
              const { field, sort } = sortModel[0];
              handleSortSupportAdmin(field, sort as 'asc' | 'desc');
            }
          }}
          getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: limitSupportAdminUser },
            },
          }}
          pageSizeOptions={[10, 20, 50]}
          rowHeight={42}
          rowCount={totalRowsAdminUserSupport}
          loading={mutation.isLoading || isFetchingPlans}
          disableColumnFilter
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            '& .first-column-cell': {
              paddingLeft: '200px',
            },
            '& .striped-row': {
              backgroundColor: '#F3F4F8',
              color: '#1B1D35',
            },
            minHeight: '150px',
            background: '#fff',
          }}
        />
      </div>
    </>
  );

  const getAdminusersdata = () => (
    <>
      <CompanyContainer>
        {updateUser && (
          <UserEditAdminModal
            isOpen={isOpenEditAdminUser}
            setIsOpen={setIsOpenEditAdminUser}
            user={updateUser}
            onSuccess={handleModalCloseAdmin}
          />
        )}
        <AddUsers
          isOpen={isModalOpenAdmin}
          setIsOpen={setIsOpenEditAdminUserAdd}
          onRequestClose={closeModalAdmin}
          onSuccess={handleModalAdminCloseAdd}
        />
        <CompanyHeader>
          <h4>Admin User</h4>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ marginTop: '10px' }}>
              <CommonInput
                id="searchQuery"
                name="searchQuery"
                placeholder="Search..."
                value={searchTermAdminUsers}
                onChange={event => {
                  let newValue = event.target.value;
                  newValue = newValue.replace(/[',.]/g, '');
                  setsearchTermAdminUsers(newValue);
                }}
                style={{
                  width: '300px',
                  marginRight: '10px',
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  padding: '4px',
                  minHeight: '30px',
                }}
                label=""
              />
            </div>
            <RegularButton style={{ marginTop: '25px' }} onClick={openModalAdmin}>
              Add Admin User
            </RegularButton>
          </div>
        </CompanyHeader>
      </CompanyContainer>
      <div style={{ alignSelf: 'right', minWidth: '100%' }}>
        <DataGrid
          rows={adminUsers?.data?.items || []}
          columns={AdminusersColumns}
          pagination
          paginationMode="server"
          onPaginationModelChange={state => {
            handlePageChangeAdminUser(state.page + 1);
            handlePerRowsChangeAdminUser(state.pageSize, state.page + 1);
          }}
          onSortModelChange={sortModel => {
            if (sortModel.length > 0) {
              const { field, sort } = sortModel[0];
              handleSortAdminUser(field, sort as 'asc' | 'desc');
            }
          }}
          getRowClassName={params => (params.indexRelativeToCurrentPage % 2 === 0 ? 'striped-row' : '')}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: limitAdminUser },
            },
          }}
          pageSizeOptions={[10, 20, 50]}
          rowHeight={42}
          rowCount={totalRowsAdminUser}
          loading={mutation.isLoading || isFetchingPlans}
          disableColumnFilter
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            '& .first-column-cell': {
              paddingLeft: '200px',
            },
            '& .striped-row': {
              backgroundColor: '#F3F4F8',
              color: '#1B1D35',
            },
            minHeight: '150px',
            background: '#fff',
          }}
        />
      </div>
    </>
  );

  useEffect(() => {
    if (data) {
      dispatch({ type: 'SET_DATA', payload: data });
      setSelectedTab(Object.keys(data)[0]);
    }
  }, [data]);

  return (
    <Container>
      <Header>
        <Title>{t('settings.title')}</Title>
      </Header>
      {isLoading || isFetching ? (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      ) : (
        <Container>
          <TabContainer>
            {tabs.map(tab => (
              // eslint-disable-next-line max-len
              <Tab
                key={tab.key}
                selected={tab.selectedTab === selectedTab}
                onClick={() => setSelectedTab(tab.selectedTab)}
              >
                <TabTitle>{tab.lable}</TabTitle>
              </Tab>
            ))}
          </TabContainer>
          {selectedTab === 'notifications' ? (
            <Content>
              {getNotificationsTabContent()} <PayrollSummariesConfigTable />
            </Content>
          ) : (
            ''
          )}
          {selectedTab === 'accrualPlan' ? <Content>{getAccrualPlanTabContent()}</Content> : ''}
          {selectedTab === 'company' ? <Content>{getCompanydata()}</Content> : ''}
          {selectedTab === 'users' ? <Content>{getUsersdata()}</Content> : ''}
          {selectedTab === 'adminUser' ? <Content>{getAdminusersdata()}</Content> : ''}
          {selectedTab === 'supportAdminUser' ? <Content>{getSupportadminusersdata()}</Content> : ''}
          {selectedTab === 'externalAdminUsers' ? <Content>{<ExternalAdminUsersTab />}</Content> : ''}
          {selectedTab === 'ExternalClientUsers' ? <Content>{<ExternalClientUsersTab />}</Content> : ''}
          {selectedTab === 'w2FormSettings' ? <Content>{<W2FormSettings />}</Content> : ''}
        </Container>
      )}
    </Container>
  );
};
